import { Injectable } from '@angular/core';
import { databases, ID } from '../config/appwrite';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TiposEspecialistaService {

  private collectionId = "t_especialistas";
  private DATABASE_NAME = environment.databaseName;

  constructor() { }

  /**
   *
   * @returns
   */
  getTiposDocumento(): Promise<any[]> {
    return databases.listDocuments(
      this.DATABASE_NAME,
      this.collectionId
    ).then(response => response.documents); //extraemos solo los documentos
  }

}
